<template>
  <v-container>
    <v-row>
      <v-col cols="2">Название проекта:</v-col>
      <v-col>{{title}}</v-col>
    </v-row>
    <v-row>
      <v-col cols="2">Количество людей в проекте:</v-col>
      <v-col>{{Kolvo}}</v-col>
    </v-row>
    <v-row>
      <v-col cols="2">Статус:</v-col>
      <v-col>{{State}}</v-col>
    </v-row>
    <v-row v-if="Rab">
      <v-col cols="2">Необходимы:</v-col>
      <v-col>
        <v-row class="pl-3" v-for="r in Rab" :key="r">{{r}}</v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ["title", "Kolvo", "State", "Rab"],
};
</script>